import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowUp } from "@react-icons/all-files/ai/AiOutlineArrowUp";

function BackToTop() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(() => window.scrollY > 520);

  useEffect(() => {
    const handleScroll = () => {
      const nextVisibility = window.scrollY > 520;
      setIsVisible((previousVisibility) =>
        previousVisibility === nextVisibility ? previousVisibility : nextVisibility
      );
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      type="button"
      className="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" })}
      aria-label={t("a11y.back_to_top")}
      title={t("a11y.back_to_top")}
    >
      <AiOutlineArrowUp aria-hidden="true" />
    </button>
  );
}

export default BackToTop;
